import React from "react";
import { useMessagesPagination, AlertParser } from "@moonscape/shared";
import AlertRow from "./AlertRow";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

import { BellAlertIcon } from "@heroicons/react/24/solid";

const Alerts = () => {
  const { isQueryLoading, items: messageItems } = useMessagesPagination({
    seen: null,
    onLoading: () => {},
  });

  const renderItems = () => {
    if (isQueryLoading) {
      return <DropdownMenuItem disabled>Loading...</DropdownMenuItem>;
    }
    if (!messageItems?.length) {
      return <DropdownMenuItem disabled>No alerts</DropdownMenuItem>;
    }
    return messageItems.map((message, index) => {
      const item = new AlertParser(message);
      return (
        <DropdownMenuItem key={index} className="p-0">
          <AlertRow
            title={item.title}
            seen={item.seen}
            datetime={item.datetime}
            value={item.value}
            imageUrl={item.imageUrl}
            href={item.href}
          />
        </DropdownMenuItem>
      );
    });
  };

  return (
    <div className="max-h-[50vh] overflow-hidden">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="flex items-center">
            <BellAlertIcon className="h-5 w-5 animate-shake-once" aria-hidden="true" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="max-h-[calc(100vh-80px)] lg:max-h-[75vh] overflow-auto scrollbar-none">
          {renderItems()}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default Alerts;
